//import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { userActions } from '../_actions';
import React, { useState } from 'react';
import { userService } from '../_services';

class DeletePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userOptions: [],
            user: { id: "", userName: "" },
            submitted: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.fGetUsernames();

    }

    handleChange(event) {
        const id = event.target.value;
        const option = this.state.userOptions.find(o => o.id === id);

        this.setState({ user: option ?? { id: '', userName: '' } });
    }

    handleSubmit = async event => {
        event.preventDefault();

        this.setState({ submitted: true });
        const { user } = this.state;
        const { dispatch } = this.props;

        try {
            const ok = await dispatch(userActions.register4(user));
            this.setState({ user: { id: '', userName: '' } });

            setTimeout(() => {
                this.fGetUsernames();
            }, 3000);

        } catch (e) {
            console.log(e);
        }
    }

    async fGetUsernames() {
        userService.getAll().then(users => {
            const userOptions = users.userList.map(u => ({
                id: u.id,
                userName: u.userName
            }));

            this.setState(
                {
                    userOptions,
                    user: { id: "", userName: "" }
                });
        });
    }

    render() {
        const { registering } = this.props;
        const { userOptions, user } = this.state;
        return (
            <div className="login col-md-6 col-md-offset-3" style={{ maxWidth: '450px' }}>
                <h2 className="heading">Delete</h2>
                <form name="form" onSubmit={this.handleSubmit}>                    
                    <div className='form-group'>
                        <div className="columns">
                            <div className="column column-1-2">
                                <label htmlFor="username">Username</label>
                            </div>
                            <div className="column column-1-2">
                                <select id="arr" input type="text" className="form-control" name="username" value={user.id} onChange={this.handleChange}>
                                    <option>-- Select a Username --</option>                                  
                                    {userOptions.map(o => (
                                        <option key={o.id} value={o.id}>
                                            {o.userName}
                                        </option>
                                    ))}
                                </select>
                                
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <button className="btn btn-primary">Delete User</button>
                        {registering &&
                            <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                        }
                        <Link to="/results" className="btn btn-link">Cancel</Link>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    registering: state.registration.registering
});

export default connect(mapStateToProps)(DeletePage);